import { Divider, Skeleton } from "@mui/material";
import { Flex } from "@src/components/shared-ui-components/Flex";
import {
  ErrorState,
  formatNumberWithCommaAndDollar,
  formatWithPercentage,
} from "@src/constants";
import Colors from "@src/constants/Colors";
import { StyledTypographySales } from "../../shared-containers/LabourTrendsCard/style";
import { InfoCardProps } from "../../shared-containers/LabourTrendsCard/type";
import { StyledBox, StyledTypogaphyAct, StyledTypographyPct } from "./style";

const InfoCard = ({
  title,
  sales,
  percentage,
  textColor,
  backgroundColor,
  loading,
  font,
  isInteger,
}: InfoCardProps) => {
  const getSales = (salesvalue: number | null) => {
    if (salesvalue !== null) {
      if (isInteger) {
        return formatNumberWithCommaAndDollar(salesvalue, 0, true);
      }
      return formatNumberWithCommaAndDollar(salesvalue);
    }
    return <ErrorState />;
  };

  let content: React.ReactNode = (
    <>
      <StyledTypogaphyAct>{getSales(sales)}</StyledTypogaphyAct>
      <Divider>
        <Divider orientation="vertical" />
      </Divider>
      <StyledTypographyPct>
        {percentage !== null ? (
          formatWithPercentage(percentage, 0, true) || ""
        ) : (
          <ErrorState />
        )}
      </StyledTypographyPct>
    </>
  );
  if (sales === null && percentage === null) content = <ErrorState />;
  if (loading)
    content = <Skeleton width="60%" sx={{ minHeight: "25px !important" }} />;

  return (
    <StyledBox>
      <StyledTypographySales
        background={backgroundColor || ""}
        sx={{
          color: textColor || Colors.neutral_gray_500,
          backgroundColor: backgroundColor || "",
          fontFamily: font || "Ringside Regular-Book !important",
        }}
      >
        {title}
      </StyledTypographySales>
      <Flex
        style={{
          flexWrap: "wrap",
          minWidth: "69px",
        }}
      >
        {content}
      </Flex>
    </StyledBox>
  );
};

export default InfoCard;
